import { Component } from '@angular/core';
import { AlertController, NavController, NavParams, ToastController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from '../../../../globals';
import { OdsServices } from '../../services';
import { TakeawayServices } from '../../../takeaway/services';
import { Uploads } from '../../../services/uploads';

/**
 * Generated class for the OdsListViewPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-ods-config-customize',
    templateUrl: 'ods-config-customize.html',
})
export class OdsConfigCustomizePage {

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public translate: TranslateService,
        public globals: Globals,
        public toastCtrl: ToastController,
        public odsServices: OdsServices,
        public takeawayServices: TakeawayServices,
        private uploadServices: Uploads,
        private alertCtrl: AlertController) {
    }

    /********************************************************/
    /*                         LOGO                         */
    /********************************************************/

    async selectFileLogo(event) {
        const file = event.target.files.item(0);
        if (file.type.match('image.*')) {
            let selectedFiles = event.target.files;
            selectedFiles = this.globals.RenameFiles(selectedFiles, this.globals.restaurant_uid);
            //Delete previous logo
            if (this.globals.restaurant.logo_share) {
                this.uploadServices.delete(this.globals.restaurant.logo_share);
            }
            //Upload file to firbase storage
            let img_ref = await this.uploadServices.uploadComplete(selectedFiles, 'logo');
            this.globals.restaurant.logo_share = img_ref;
            //Update to firebase
            this.updateLogo(img_ref);
            //Get url from image uploaded
            this.globals.getLogoImageUrl(img_ref, 'share');
        } else {
            alert('invalid format!');
        }
    }

    updateLogo(img_ref) {
        this.globals.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
            'logo_share': img_ref
        });
    }

    deleteLogo() {
        let alert = this.alertCtrl.create({
            title: this.translate.instant('instant-eliminar-imagen'),
            message: this.translate.instant('instant-seguro-quieres-eliminar-imagen'),
            buttons: [
                {
                    text: this.translate.instant('general-no'),
                    role: 'cancel',
                    handler: () => {
                    }
                },
                {
                    text: this.translate.instant('general-si'),
                    handler: () => {
                        this.uploadServices.delete(this.globals.restaurant.logo_share);
                        this.globals.logo_share_url = null;
                        this.globals.restaurant.logo_share = null;
                        this.updateLogo(null);
                    }
                }
            ]
        });
        alert.present();
    }

    /********************************************************/
    /*                         REST                         */
    /********************************************************/

    async selectFileRest(event) {
        const file = event.target.files.item(0);
        if (file.type.match('image.*')) {
            //File selected
            let selectedFiles = event.target.files;
            selectedFiles = this.globals.RenameFiles(selectedFiles, this.globals.restaurant_uid)

            //Delete previous logo
            if (this.globals.restaurant.image) {
                this.uploadServices.delete(this.globals.restaurant.image);
            }
            //Upload file to firbase storage
            let img_ref = await this.uploadServices.uploadComplete(selectedFiles, 'restaurants');
            this.globals.restaurant.image = img_ref;
            //Update data to firestore
            this.updateRest(img_ref);
            //Get url from image uploaded
            this.globals.getRestImageUrl(img_ref);
        } else {
            alert('invalid format!');
        }
    }

    updateRest(img_ref) {
        this.globals.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
            'image': img_ref
        });
    }

    deleteRest() {
        let alert = this.alertCtrl.create({
            title: this.translate.instant('instant-eliminar-imagen'),
            message: this.translate.instant('instant-seguro-quieres-eliminar-imagen'),
            buttons: [
                {
                    text: this.translate.instant('general-no'),
                    role: 'cancel',
                    handler: () => {
                    }
                },
                {
                    text: this.translate.instant('general-si'),
                    handler: () => {
                        this.uploadServices.delete(this.globals.restaurant.image);
                        this.globals.rest_image_url = null;
                        this.updateRest(null);
                    }
                }
            ]
        });
        alert.present();
    }

    /********************************************************/
    /*                         OTROS                        */
    /********************************************************/

    getBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }

    next() {
        if (!this.odsServices.takeaway_config.config_customize) {
            this.odsServices.firestore.collection('restaurants/' + this.globals.restaurant_uid + '/takeaway').doc('config').update({
                config_customize: true
            });
            this.odsServices.takeaway_config.config_customize = true;
        }
        this.navCtrl.pop();
    }
}


// WEBPACK FOOTER //
// ./src/pages/ods/ods-config/ods-config-customize/ods-config-customize.ts